import '.g7{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.g8{padding-left:1.5rem;}.ssr-plugin'
import '.g9{margin:1rem 0;}.ssr-plugin'
import '.ga{color:var(--gray-700);}.ssr-plugin'
import '.gb{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g7 g8 g9 ga gb"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
